const DEFAULT_SITE_KEY = '6LePGdstAAAAAOhP3NT8CpCnI1KPmrh13hCgXXpd';

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || DEFAULT_SITE_KEY;

/**
 *
 * @param {*} setScript this is a useState setter
 * @param {*} SITE_KEY this is a recaptcha site key
 */
export const createCaptcha = (setScript, SITE_KEY = RECAPTCHA_SITE_KEY) => {
    const head = document.getElementsByTagName('head')[0];
    const scriptElement = document.createElement('script');
    scriptElement.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
    scriptElement.type = 'text/javascript';
    scriptElement.id = 'testScriptName';
    setScript(scriptElement);
    head.appendChild(scriptElement);
};

export const deletCaptcha = () => {
    const captcha = document.getElementsByClassName('grecaptcha-badge');
    captcha[0] && (captcha[0].style.visibility = 'hidden');
};

export const showCaptcha = () => {
    const captcha = document.getElementsByClassName('grecaptcha-badge');
    captcha[0] && (captcha[0].style.visibility = '');
};
